module.exports = __webpack_public_path__ + "img/yuanlinlvhua.86cad1ca.png";